import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="ja-container py-32 text-center" data-testid="not-found">
      <p className="ja-overline">404</p>
      <h1 className="ja-serif text-6xl md:text-7xl mt-4 tracking-tight">Lost in the Atelier.</h1>
      <p className="mt-4 text-sm" style={{ color: "var(--ja-muted)" }}>This page is no longer on display.</p>
      <Link to="/" className="ja-btn mt-10">Return Home</Link>
    </div>
  );
}
